import script from "./BaseAiInsightCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseAiInsightCard.vue?vue&type=script&setup=true&lang=ts"

import "./BaseAiInsightCard.vue?vue&type=style&index=0&id=e6708e98&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6708e98"]])

export default __exports__